import React from "react";
import { LucideIcon } from "lucide-react";

interface CardActionItemProps {
  icon: LucideIcon;
  title: string;
  description: string;
  onClick: () => void;
  variant?: "default" | "primary";
}

export const CardActionItem: React.FC<CardActionItemProps> = ({
  icon: Icon,
  title,
  description,
  onClick,
  variant = "default"
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        bg-card hover:bg-accent/50 border border-border rounded-lg p-6 cursor-pointer 
        transition-all duration-300 h-full flex flex-col shadow-sm hover:shadow-md
        ${variant === "primary" ? "ring-2 ring-primary/20 bg-gradient-to-br from-primary/5 to-primary/10" : ""}
      `}
    >
      <div className="flex items-center mb-4">
        <div className={`
          p-2 rounded-full 
          ${variant === "primary" 
            ? "bg-gradient-to-r from-primary to-primary/80 text-white" 
            : "bg-primary/10 text-primary"
          }
        `}>
          <Icon className="h-6 w-6" />
        </div>
      </div>
      <h3 className="text-lg font-medium mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground flex-1">{description}</p>
    </div>
  );
};